module.exports = __webpack_public_path__ + "static/img/board_b08.7632488.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/board_b08.jpg
// module id = gdE8
// module chunks = 0